// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2qy0Y","bigColWidth":"Table_bigColWidth__8yFgX","biggerColWidth":"Table_biggerColWidth__BtSuo","row":"Table_row__2BTbT","col":"Table_col__3yhph"};